import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "mt-2 border border-gray-400 rounded" }
const _hoisted_2 = { class: "px-4 py-2 bg-gray-100 border-b border-gray-400" }
const _hoisted_3 = { class: "mt-1" }
const _hoisted_4 = {
  key: 0,
  class: "px-2 text-sm text-white capitalize rounded-full bg-success w-fit"
}
const _hoisted_5 = {
  key: 1,
  class: "px-2 text-sm text-black capitalize rounded-full bg-warning w-fit"
}
const _hoisted_6 = {
  key: 2,
  class: "px-2 text-sm text-white capitalize bg-red-400 rounded-full w-fit"
}
const _hoisted_7 = {
  key: 3,
  class: "px-2 text-sm text-black capitalize bg-gray-400 rounded-full w-fit"
}
const _hoisted_8 = {
  key: 4,
  class: "px-2 text-sm text-white capitalize bg-red-400 rounded-full w-fit"
}
const _hoisted_9 = { class: "capitalize" }
const _hoisted_10 = {
  key: 0,
  class: "pt-0"
}
const _hoisted_11 = { key: 1 }
const _hoisted_12 = { class: "flex pt-0 space-x-4" }
const _hoisted_13 = { class: "text-sm text-gray-600" }
const _hoisted_14 = { class: "mt-6" }
const _hoisted_15 = { class: "mx-2 text-2xl font-medium" }
const _hoisted_16 = { class: "mt-2" }

import { PropType, ref } from "vue";
import { storeToRefs } from "pinia";

import RoleGuard from "./RoleGuard.vue";
import ListRowItem from "./ListRowItem.vue";
import DefaultButton from "./DefaultButton.vue";
import TimezoneSpan from "./TimezoneSpan.vue";

import { User } from "@/types";
import { useGlobalStore, useUserStore } from "@/store";
import api from "@/api/api";
import { useI18n } from "vue-i18n";
import { getUsersHighestRole } from "@/utils/roles";


export default /*#__PURE__*/_defineComponent({
  __name: 'SubscriptionPanel',
  props: {
  user: {
    type: Object as PropType<User>,
    required: true,
  },
},
  emits: ["update"],
  setup(__props, { emit }) {

const props = __props;

const { t: $t } = useI18n();
const globalStore = useGlobalStore();
const { user: currentUser } = storeToRefs(useUserStore());
const userStore = useUserStore();

const isLoading = ref(false);
const isSubscribingUser = ref(false);
const subscriptionProviders = ["stripe", "2checkout"];




const auto_renew = ref(props.user.auto_renew);

async function toggleAutoRenew() {
  try {
    isLoading.value = true;
    if (props.user.subscription_merchant_name === "stripe") {
      const data = (await api.users.toggleStripeAutoRenew(props.user)).data.data;

      if (data.auto_renew === "-1") {
        return;
      }

      auto_renew.value = data.auto_renew as boolean;
      isLoading.value = false;
    }

    if (props.user.subscription_merchant_name === "2checkout") {
      const data = (await api.users.toggleTwoCheckoutAutoRenew(props.user)).data.data;

      if (data.auto_renew === "-1") {
        return;
      }

      auto_renew.value = data.auto_renew as boolean;
      console.log("2checkout", auto_renew.value);
      isLoading.value = false;
    }
  } catch (error) {
    console.log(error);
  } finally {
    await userStore.fetchUser();
    isLoading.value = false;
  }
}

function formatHeader() {
  const role = getUsersHighestRole(props.user.roles).display_name;
  console.log("subs role", role);

  let display_role = role;

  if (display_role === "Advanced Facilitator Trainee") {
    return "Certified Facilitator";
  }

  if (display_role.toLowerCase() === "level 04a trainee" || display_role.toLowerCase() === "trainee trainer") {
    return "Advanced Facilitator";
  }

  return display_role;
}

async function subscribeUser() {
  try {
    isSubscribingUser.value = true;
    await api.users.manualSubscribeUser(props.user);

    emit("update");

    globalStore.toast("SUCCESS", $t("user-subscribed"));
  } catch (error) {
    console.log(error);
  } finally {
    isSubscribingUser.value = false;
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, _toDisplayString(_unref($t)("current-subscription")), 1),
      _createVNode(ListRowItem, {
        title: _unref($t)('level')
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", null, _toDisplayString(formatHeader()), 1)
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(ListRowItem, {
        title: _unref($t)('status')
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            (__props.user.subscription_status === 'active')
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_unref($t)("active")), 1))
              : _createCommentVNode("", true),
            (__props.user.subscription_status === 'pending')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_unref($t)("pending")), 1))
              : _createCommentVNode("", true),
            (__props.user.subscription_status === 'expired')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, _toDisplayString(_unref($t)("expired")), 1))
              : _createCommentVNode("", true),
            (__props.user.subscription_status === 'none')
              ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref($t)("none")), 1))
              : _createCommentVNode("", true),
            (__props.user.subscription_status === 'cancelled')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, _toDisplayString(_unref($t)("cancelled")), 1))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(ListRowItem, {
        title: _unref($t)('expiration')
      }, {
        default: _withCtx(() => [
          _createVNode(TimezoneSpan, {
            date: __props.user.subscription_end,
            locale: "en-GB",
            "date-style": "short",
            "time-style": "short"
          }, null, 8, ["date"])
        ]),
        _: 1
      }, 8, ["title"]),
      _createVNode(ListRowItem, {
        title: _unref($t)('payment-type')
      }, {
        default: _withCtx(() => [
          _createElementVNode("p", _hoisted_9, _toDisplayString(__props.user.subscription_merchant_name), 1)
        ]),
        _: 1
      }, 8, ["title"]),
      (subscriptionProviders.includes(__props.user.subscription_merchant_name))
        ? (_openBlock(), _createBlock(ListRowItem, {
            key: 0,
            title: _unref($t)('auto-renew')
          }, {
            default: _withCtx(() => [
              (_unref(currentUser).id !== __props.user.id)
                ? (_openBlock(), _createElementBlock("p", _hoisted_10, _toDisplayString(__props.user.auto_renew ? _unref($t)("yes") : _unref($t)("no")), 1))
                : _createCommentVNode("", true),
              (_unref(currentUser).id === __props.user.id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                    _createElementVNode("div", _hoisted_12, [
                      _createVNode(DefaultButton, {
                        class: _normalizeClass(["hover:underline", { '!cursor-wait': isLoading.value }]),
                        type: auto_renew.value ? 'text-danger' : 'text',
                        onClick: toggleAutoRenew,
                        disabled: isLoading.value
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(auto_renew.value ? _unref($t)("turn-off") : _unref($t)("turn-on")), 1)
                        ]),
                        _: 1
                      }, 8, ["class", "type", "disabled"])
                    ]),
                    _createElementVNode("div", _hoisted_13, [
                      _createElementVNode("p", null, _toDisplayString(_unref($t)("auto-renew-explainer")), 1),
                      _createElementVNode("p", null, _toDisplayString(_unref($t)("auto-renew-warning")), 1)
                    ])
                  ]))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["title"]))
        : _createCommentVNode("", true)
    ]),
    (__props.user.subscription_status !== 'active')
      ? (_openBlock(), _createBlock(RoleGuard, {
          key: 0,
          roles: ['admin', 'users-admin']
        }, {
          default: _withCtx(() => [
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("h3", _hoisted_15, _toDisplayString(_unref($t)("manual-subscription")), 1),
              _createElementVNode("div", _hoisted_16, [
                _createVNode(DefaultButton, {
                  type: "primary",
                  onClick: subscribeUser,
                  loading: isSubscribingUser.value
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_unref($t)("subscribe-user")), 1)
                  ]),
                  _: 1
                }, 8, ["loading"])
              ])
            ])
          ]),
          _: 1
        }))
      : _createCommentVNode("", true)
  ], 64))
}
}

})